module.exports = __webpack_public_path__ + "public/HelpPage/block3img.jpeg?6304179f";